import {parseQueryString} from '@vio/core/src/utils/url'

type Value = string | null | undefined

/**
 * Return forced toggle variations from the URL search query.
 * Looks for ab_experimentId=experimentVariation, and returns an object in the form of `{ experimentId: experimentVariation }`.
 * For example ab_foo=a&ab_bar=b would yield: `{ foo: 'a', bar: 'b' }`
 */
export const getForcedTogglesFromSearchQuery = (
  url: string
): Record<string, Value> => {
  const FORCE_PREFIX = 'ab_'
  const params = parseQueryString(url)
  const result: Record<string, Value> = {}

  for (const [key, value] of Object.entries(params)) {
    if (key.startsWith(FORCE_PREFIX)) {
      result[key.slice(FORCE_PREFIX.length)] = value as Value
    }
  }

  return result
}

/**
 * Parse experiments decided in CloudFront lamba and passed to the server in the header
 * @param header - header value, expected format: "an-experiment-key=a,another-experiment-key=b"
 * @returns an object of experiment keys and enabled boolean
 */
export const parseExperimentHeader = (
  header: string | string[]
): Record<string, string> => {
  if (!header || typeof header !== 'string') return {}

  return header.split(',').reduce(
    (acc, experiment) => {
      const [key, value] = experiment.split('=').map(s => s.trim())
      if (key && value) {
        acc[key] = value
      }
      return acc
    },
    {} as Record<string, string>
  )
}
